module.exports = __webpack_public_path__ + "files/eb2d0c1a5104d8ce0e0df0ef0b80c9fc.svg";